import React, { PropsWithChildren, useContext } from 'react'

import { MediaQuery, MobileProps, withMobile } from 'component-library-next'

export type MobileContextValue = {
  innerWidth: number
  innerHeight: number
  mediaQuery: MediaQuery
  mobile: boolean
  isMobile: boolean
}

const MobileContext = React.createContext<MobileProps & { isMobile: boolean }>(
  {} as MobileContextValue
)

export const MobileProvider = withMobile(
  ({ mobile, children, ...rest }: PropsWithChildren<MobileProps>) => {
    return (
      <MobileContext.Provider value={{ ...rest, mobile: mobile, isMobile: mobile }}>
        {children}
      </MobileContext.Provider>
    )
  }
)

export const useMobile = () => {
  return useContext(MobileContext)
}
